export const projects: TProject[] = [
  {
    image: "/images/logo-sp-exchange.png",
    name: "SP Exchange",
    position: "Lead Developer",
    backgroundImage: "/images/bg-sp-exchange.png",
  },
  {
    image: "/images/logo-sp-p2p.png",
    name: "SP P2P",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-sp-p2p.png",
  },
  {
    image: "/images/logo-infinity-angel-game.png",
    name: "Infinity Angel",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-infinity-angel-game.png",
  },
  {
    image: "/images/logo-immortal-wars-game.png",
    name: "Immortal Wars",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-immortal-wars.png",
  },
  {
    image: "/images/logo-kt-raon.png",
    name: "KT Raon",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-kt-raon.jpg",
  },
  {
    image: "/images/logo-sprint.png",
    name: "Sprint",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-sprint.png",
  },
  {
    image: "/images/logo-airtnt.png",
    name: "Airtnt",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-airtnt.png",
  },
  {
    image: "/images/logo-kungfu-cat.png",
    name: "Kungfu Cat",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-kungfu-cat.png",
  },
  {
    image: "/images/logo-babylaika.png",
    name: "Babylaika",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-babylaika.png",
  },
  {
    image: "/images/logo-matrix3s.png",
    name: "Matrix 3S",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-matrix3s.jpg",
  },
  {
    image: "/images/logo-yousui.png",
    name: "Yousui",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-yousui.jpg",
  },
  {
    image: "/images/logo-tamadama.png",
    name: "Tamadama",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-tamadama.jpg",
  },
  {
    image: "/images/logo-nikkeineko.png",
    name: "Nikkeineko",
    position: "Full Stack Developer",
    backgroundImage: "/images/bg-nikkeineko.png",
  },
  {
    image: "/images/logo-coincraze.png",
    backgroundImage: "/images/bg-coincraze.png",
    name: "Coincraze",
    position: "Full Stack Developer",
    description: "Explore Coincraze Central, a vibrant community with exclusive Airdrops, Retroactive rewards, Free Tokens, and advanced Mining in a Blockchain-driven, entertaining crypto world.",
    features: [
      `News and Updates: Stay informed with the latest cryptocurrency news, market trends, and updates from the Coincraze ecosystem.`,
      `Trading Bots: Bot trade futures allowing users to automate their trading strategies and maximize profits.`,
      `Quest System: Engage in quests to earn rewards and enhance your experience within the Coincraze community.`,
      `Affiliate Program: Invite friends and earn commissions through our affiliate program, expanding the Coincraze network.`,
      `Support Center: Access a comprehensive support center to assist users with any questions or issues they may encounter.`,
      `Announcements: Keep up with important announcements and developments within the Coincraze platform.`,
    ]

  },
].reverse();
